// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eqb3i","type":"styles_type__JQRxs","choices":"styles_choices__1ZdRz"};